import { z } from 'zod';

export const errorStatusSchema = z.object({
  status_code: z.number(),
  status_text: z.string(),
  status_id: z.string().optional(),
});

export type ErrorStatus = z.infer<typeof errorStatusSchema>;

export const errorStatusStringSchema = z
  .string()
  .transform((text, ctx) => {
    try {
      return JSON.parse(text);
    } catch {
      ctx.addIssue({
        code: 'custom',
        message: 'Invalid JSON format',
      });
      return z.NEVER; // indicate a failure
    }
  })
  .pipe(errorStatusSchema);
